<div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">API Tokens</h5>
    <button type="button" class="btn btn-primary" data-type="create-api-token">
        <i class="ti ti-plus me-1"></i>Create Token
    </button>
</div>
<div id="api-tokens-container">
    <p class="text-muted">Loading API tokens...</p>
</div>

<!-- Create API Token Modal -->
<div class="modal fade" id="createApiTokenModal" tabindex="-1" aria-labelledby="createApiTokenModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="createApiTokenModalLabel">Create API Token</h5>
                <button type="button" class="btn-close" data-type="apitoken-modal-close" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form id="create-api-token-form">
                    <div class="mb-3">
                        <label class="form-label">Description</label>
                        <textarea class="form-control"
                                  id="create-apitoken-description"
                                  name="description"
                                  rows="3"
                                  placeholder="Optional description for this token"></textarea>
                    </div>
                    <div class="mb-3">
                        <div class="form-check">
                            <input class="form-check-input"
                                   type="checkbox"
                                   id="create-apitoken-never-expires"
                                   name="neverExpires"
                                   checked>
                            <label class="form-check-label" for="create-apitoken-never-expires">
                                Token never expires
                            </label>
                        </div>
                    </div>
                    <div class="mb-3" id="expiration-date-container" style="display: none;">
                        <label class="form-label">Expiration Date</label>
                        <input type="date"
                               class="form-control"
                               id="create-apitoken-expires"
                               name="expiresAt">
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-type="apitoken-modal-cancel">Cancel</button>
                <button type="button" class="btn btn-primary" data-type="apitoken-modal-save">Create</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit API Token Modal -->
<div class="modal fade" id="editApiTokenModal" tabindex="-1" aria-labelledby="editApiTokenModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editApiTokenModalLabel">Edit API Token</h5>
                <button type="button" class="btn-close" data-type="edit-apitoken-modal-close" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form id="edit-api-token-form">
                    <div class="mb-3">
                        <label class="form-label">Description</label>
                        <textarea class="form-control"
                                  id="edit-apitoken-description"
                                  name="description"
                                  rows="3"
                                  placeholder="Optional description for this token"></textarea>
                    </div>
                    <div class="mb-3">
                        <div class="form-check">
                            <input class="form-check-input"
                                   type="checkbox"
                                   id="edit-apitoken-never-expires"
                                   name="neverExpires"
                                   checked>
                            <label class="form-check-label" for="edit-apitoken-never-expires">
                                Token never expires
                            </label>
                        </div>
                    </div>
                    <div class="mb-3" id="edit-expiration-date-container" style="display: none;">
                        <label class="form-label">Expiration Date</label>
                        <input type="date"
                               class="form-control"
                               id="edit-apitoken-expires"
                               name="expiresAt">
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-type="edit-apitoken-modal-cancel">Cancel</button>
                <button type="button" class="btn btn-primary" data-type="edit-apitoken-modal-save">Save</button>
            </div>
        </div>
    </div>
</div>
